import * as React from "react";

function SvgPortalLogo(props) {
  return (
    <svg data-name="Group 11873" xmlns="http://www.w3.org/2000/svg" width={130.319} height={76.957} {...props}>
      <path data-name="Path 43740" d="M98.04 63.61a10.174 10.174 0 00-6.546 12.14 10.174 10.174 0 006.546-12.14z" fill="#3c4252" />
      <path data-name="Path 43741" d="M103.194 68.608a10.174 10.174 0 01-11.818 7.11 10.174 10.174 0 0111.818-7.11z" fill="#039be5" />
      <path data-name="Rectangle 3992" fill="#2f2e41" d="M0 76.666h130.319v.291H0z" />
      <path
        data-name="Path 43742"
        d="M52.633 63.281a13.882 13.882 0 01-5.2-2.1l.172-.235a13.579 13.579 0 005.09 2.052c2.754.495 6.874.252 10.866-3.713 7.769-7.716 15.184-8.493 15.257-8.5l.027.29c-.073.007-7.384.773-15.079 8.416a12.492 12.492 0 01-8.977 3.985 12.143 12.143 0 01-2.156-.195z"
        fill="#3d4251"
      />
      <circle data-name="Ellipse 850" cx={1.745} cy={1.745} r={1.745} transform="translate(73.181 53.686)" fill="#3c4252" />
      <circle data-name="Ellipse 851" cx={1.745} cy={1.745} r={1.745} transform="translate(60.819 61.831)" fill="#3c4252" />
      <path
        data-name="Path 43743"
        d="M99.407 76.812a59.616 59.616 0 00-7.6-1.577l.111-1.55c.873-8.727-4.945-21.817-4.945-21.817a58.406 58.406 0 013.123 20.22 8.481 8.481 0 00-5.159-3.712s3.749 3.215 4.823 6.56a145.132 145.132 0 00-14.839-1.195l1.289-2.965-2.473 2.473s-1.018-7.418-3.2-7.709l1.6 7.272s-1.891-1.454-2.327-1.309l1.076 2.152a225.39 225.39 0 00-25.855 1.3l1.217-2.8-2.473 2.473s-1.018-7.418-3.2-7.709l1.6 7.272s-1.891-1.454-2.327-1.309l1.257 2.514q-4.9.582-10.2 1.413z"
        fill="#3c4252"
      />
      <path
        data-name="Path 43744"
        d="M59.29 6.471c-1.585 1.709 2.56 5.856 2.56 5.856s-8.393 1.415-7.727 1.329.321-7.146.321-7.146 6.432-1.748 4.846-.039z"
        fill="#a0616a"
      />
      <path
        data-name="Path 43745"
        d="M65.133 24.758l-7.293 3.725-3.96 2.27s-4.669 5.881-5.54 9.366 3.771 9.926 4.3 10.592a7.908 7.908 0 01.726 1.08c.181.27 1.75-.079 3.462-.446s-.227-2.9-.227-2.9-2.186-5.584-2.349-5.71-.669-1.083-.3-1.506a3.774 3.774 0 00.792-1.294 4.375 4.375 0 01.609-1.155s6.6-5.358 8.658-7.182 7.538-.678 7.538-.678-2.586 9.919-3.233 10.589a2.144 2.144 0 00-.424 2.4c.293 1.135 4.113.057 4.113.057l1.411-3.848a63.917 63.917 0 003.534-10.134 4.326 4.326 0 00-1.908-5 6.02 6.02 0 00-4.368-.869l-6.741 1.183 4.676-2.014z"
        fill="#4f4d55"
      />
      <path
        data-name="Path 43746"
        d="M38.234 15.17l-8.706-2.692s-3.517-4.533-1.86-5.333 3.731 3.919 3.731 3.919l6.063.392z"
        fill="#a0616a"
      />
      <path data-name="Path 43747" d="M74.831 10.458l7.74-4.81s2.253-5.276.448-5.63-2.616 4.736-2.616 4.736L74.637 6.67z" fill="#a0616a" />
      <path
        data-name="Path 43748"
        d="M76.279 5.02l.148 5.7-13.045 2.331c1.919 4.105 1.431 8.777 6.261 10.825l-16.279 7.962c.725-6.26-2.3-10.975-5.129-16.837-3.445-1.249-7.446-.333-11.685 1.5l-.762-5.914 18.018-1.294 2.96 1.131 3.173-1.335c4.665-1.38 11.361-4.014 16.34-4.069z"
        fill="#039be5"
      />
      <path
        data-name="Path 43749"
        d="M68.162 43.726c-.4.344-.764 3.178-.778 4.206s1.34 1.294 2.08 1.345.651.5 1.14.88 2.094.317 4.2-.395-1.419-3.044-1.726-3.151a19.622 19.622 0 01-1.6-3.313s-2.921.083-3.316.428z"
        fill="#4f4d55"
      />
      <path
        data-name="Path 43750"
        d="M56.632 50.196c.47.233 1.544 2.881 1.818 3.872s-.968 1.591-1.671 1.828-.5.651-.88 1.14-1.945.837-4.165.683.6-3.3.871-3.485a19.623 19.623 0 00.708-3.611s2.849-.66 3.319-.427z"
        fill="#4f4d55"
      />
      <circle data-name="Ellipse 852" cx={3.49} cy={3.49} r={3.49} transform="translate(53.157 1.663)" fill="#a0616a" />
      <path
        data-name="Path 43751"
        d="M52.613 4.803a3.32 3.32 0 01-.121-2.7A3.226 3.226 0 0155.237.154c3.58-.554 5.485 1.954 5.385 2.774s-.581 2.8-.581 2.8.215-1.877-.707-1.943-4.495-.346-5.4.6a2.07 2.07 0 00-.54 2.011z"
        fill="#3c4252"
      />
    </svg>
  );
}

export default SvgPortalLogo;
